// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"414":"ChefPackageDetail","684":"Admin","7727":"ImagePipelineDetail"}[chunkId] || chunkId) + "." + {"414":"4c51b66e","625":"ffdbb008","684":"4c51b66e","1071":"4c51b66e","3927":"fa5fd79e","4297":"0929a6e6","7727":"fc554076","8579":"b31c3659"}[chunkId] + ".chunk.css";
};